import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { brandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import {
  resolveFontFamily,
  resolveThemeUIFontSizes,
} from '@jotta/ui/FontConfig'

import './theme.css'

export const haleboptheme: BrandTheme = merge.all<
  BrandTheme,
  PartialBrandTheme
>(brandTheme, {
  branding: {
    brand: 'HALEBOP',
    themedir: dirname(new URL(import.meta.url).pathname),
    staticDir: 'halebop',
    height: 32,
  },
  fontSizes: resolveThemeUIFontSizes('halebop'),
  fonts: resolveFontFamily('halebop'),
  fontWeights: {
    light: 300,
    body: 400,
    heading: 500,
    bold: 500,
  },
  colors: {
    text: '#282a2f',
    background: '#fff',
    primary: '#23A770',
    secondary: '#9EDCDC',
    accent: '#FDF238',
    accentText: '#282a2f',
    focus: '#23A770',
    focusDark: '#9EDCDC',
    border: '#eaeaea',
    success: '#5acc9e',
    graySlateBgColor: '#45434c',
    photoSearchBg: 'white',
  },
  buttons: {
    primary: {
      backgroundColor: 'accent',
      color: 'accentText',
      lineHeight: '34px',
      fontSize: '15px',
      fontWeight: 'light',
      border: '3px solid #282a2f',
      borderRadius: '0',
      padding: '0 8px',
      width: 'auto',
      minWidth: '128px',
      '&:not(:disabled):hover': {
        filter: 'brightness(.9)',
        opacity: 1,
      },
    },
    secondary: {
      variant: 'buttons.primary',
      border: '1px solid #DDDDDE',
      color: '#58585B',
      background: '#fff',
      borderRadius: '2px',
      '&:not(:disabled):hover': {
        filter: 'brightness(0.9)',
        opacity: 0.9,
      },
    },
    error: {
      '&:not(:disabled):hover': {
        filter: 'brightness(0.9)',
      },
    },
    download: {
      backgroundColor: 'accent',
      color: 'accentText',
      border: '3px solid #282a2f',
      borderRadius: 0,
      '&:not(:disabled):hover': {
        boxShadow: 'none',
        transform: 'none',
        border: '3px solid #282a2f',
      },
      ':focus': {
        boxShadow: 'none',
        transform: 'none',
        border: '3px solid #282a2f',
      },
    },
    languageSelector: {
      border: '3px solid #282a2f',
    },
    replyButton: {
      color: 'var(--color-carousel-background)',
    },
    replyButtonDarkMode: {
      color: 'background',
    },
  },
  forms: {
    toggle: {
      '&:checked::before': {
        backgroundColor: 'accentText',
      },
      '&:checked::after': {
        backgroundColor: 'accentText',
      },
    },
    checkbox: {
      fontSize: '11px',
      borderRadius: '3px',
      border: '1px solid',
    },
  },
  layout: {
    appTopToolbar: {
      fontSize: [1, 3, 3],
    },
    appHeader: {
      backgroundColor: 'secondary',
    },
    appHeaderHamburger: {
      color: '#45434C',
      '> svg': {
        color: '#45434C',
        opacity: 1,
        '&:hover': {
          color: '#333',
        },
      },
    },
    appHeaderDownload: {
      backgroundColor: 'secondary',
      borderBottom: 'none',
      borderBottomColor: 'transparent',
    },
    downloadSectionContainer1: {
      backgroundColor: 'secondary',
    },
    downloadSectionContainer2: {
      backgroundColor: 'secondary',
    },
    downloadPageContainer: {
      backgroundColor: 'secondary',
    },
    downloadSection: {
      backgroundColor: 'secondary',
    },
    modalBackgroundPrimary: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      svg: {
        filter: 'saturate(0%)',
      },
    },
  },
  cards: {
    photoUploadSuccess: {
      '--action-button-text-opacity': 1,
    },
    photoUpload: {
      '--action-button-text-opacity': 1,
    },
  },
  tables: {
    responsiveTable: {
      td: {
        pt: [0, 4, 4],
      },
    },
  },
  styles: {
    h1: {
      fontSize: 6,
    },
    avatar: {
      borderRadius: '100%',
      fontSize: '13px',
      fontWeight: 'body',
      width: '36px',
      height: '36px',
      lineHeight: '36px',
    },
    timelineHeading: {
      fontFamily: 'heading',
      fontWeight: 'heading',
      alignSelf: 'flex-end',
      marginBlockEnd: 0,
      marginBlockStart: 0,
      fontSize: 5,
      color: 'graySlateBgColor',
    },
    downloadPageHeader: {
      backgroundColor: 'white',
      color: 'black',
      padding: '0 15px',
      margin: 'auto',
    },
    headerText: {
      fontSize: 6,
      fontWeight: 'bold',
      padding: '0 8px',
      display: 'table',
      margin: 'auto',
      backgroundColor: 'accent',
    },
    subHeaderText: {
      opacity: 1,
      fontWeight: 'bold',
    },
    downloadSvg: {
      color: 'black',
    },
    fileIcon: {
      '--file-icon-border-color': '#656565',
      '--folder-icon-fill': '#f8f8f8',
    },
    defaultProfilePicSvg: { color: 'secondary' },
  },
})
export default haleboptheme
